/* global schoolList */
/* global selectedSchool */

import { select, selectAll, getHeight, closest, on, delegate, getAttribute, getModuleOptions, addClass, removeClass } from 'modules/dom';
import { initializeModuleForEl } from '../../src/js/lib/init-modules';
import debounce from 'lodash.debounce';
import nanoajax from 'nanoajax';

const MODULE_NAME = 'signup-form';
const wrapper = select('.js-wrapper');
const header = select('.header', wrapper);
const anchorClass = '.form__error';
const emailELClass = '.js-gfield-email input';
const schoolElClass = '.js-gfield-school select';
const stateElClass = '.js-gfield-state select';
const ZIPCODE_SELECTOR = '.js-gfield-zipcode input';
const INVALID_ZIPCODE_CLASS = 'signup-form--invalid-zipcode';
const LOADING_CLASS = 'signup-form--loading';
const SCHOOL_GROUP_CLASS = '.js-gfield-school';
const JOB_PROFESSOR = '.js-gfield-job input[value="Professor"]';
const GRADE_COLLEGE = '.js-gfield-grades input[value="College"]';
let MBSchool = null

const disableSelector = (selector) => {
  selector.disabled = true;
};

const enableSelector = (selector) => {
  selector.disabled = false;
};

const fetchData = (url) => new Promise((resolve, reject) => {
  nanoajax.ajax({
      url: url,
      method: 'GET',
      responseType: 'json'
    },
    (code, response) => {
      if (code === 200 && response) {
        resolve(response);
      } else {
        reject(response);
      }
    });
});

const emptySelector = (selector) => {
  selector.innerHTML = '';
};

const appendOption = (selector, value, isSelected = false, customText = false) => {
  const opt = document.createElement('option');
  if (isSelected) {
    opt.setAttribute('selected', 'selected');
  }
  opt.appendChild(document.createTextNode(customText ? customText : value));
  opt.value = value;
  selector.appendChild(opt);
};

const sortByName = (a, b) => {
  return (a['attributes']['SCH_NAME'] > b['attributes']['SCH_NAME']) ? 1 : -1;
};

export default function (el) {
  const jobProfessor = select(JOB_PROFESSOR, el)
  const gradeCollege = select(GRADE_COLLEGE, el)
  const anchor = select(anchorClass, el);
  const schoolEl = selectAll(schoolElClass, el);
  const emailEl = select(emailELClass, el);
  const stateEl = selectAll(stateElClass, el);
  const zipCodeEl = select(ZIPCODE_SELECTOR, el);
  const options = getModuleOptions(MODULE_NAME, el);
  const zipcodeErrorMessage = options.zipcodeErrorMessage || 'No school could be found for your zip code. Would you like to continue with a blank school filled?';
  const form = select('form', el);
  const formUpdateAcc = select('.js-signup-section form', el);

  if (formUpdateAcc) {
    const requiredArr = [];
    for (let i = 0, max = formUpdateAcc.length; i < max; i += 1) {
      if (formUpdateAcc[i].ariaRequired === 'true' && !formUpdateAcc[i].disabled) {
        requiredArr.push([formUpdateAcc[i].ariaRequired, formUpdateAcc[i].value]);
      }
    }
    if ((requiredArr.some(function(o){return o[1] === '';}) === true)) {
      document.body.classList.add('invalid-required-field');
    }
  }

  if (anchor) {
    const conceptEl = closest('.form__col', anchor);
    const heightHeader = getHeight(header);
    wrapper.scrollTop = conceptEl.getBoundingClientRect().top - heightHeader - 30;
  }

  if (schoolEl && stateEl && zipCodeEl) {
    const capitalizeSchoolName = (schoolName) => {
      return schoolName.split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
    };

    schoolEl.map(item => {
      item.innerHTML = '';
      appendOption(item, '', true, 'Enter Zip Code First');
    });

    const updateSchool = (data) => {
      schoolEl.map(item => {
        item.innerHTML = '';
        appendOption(item, '', false, 'Select your school');
        if (data && data['features'] && data['features'].length) {
          const schools = data['features'].sort((a, b) => sortByName(a, b));
          schools.map((attributes) => {
            const schoolName = attributes['attributes']['SCH_NAME'];
            const isSelectedSchool = options.schoolName && (schoolName.toLowerCase() === options.schoolName.toLowerCase());
            appendOption(item, capitalizeSchoolName(schoolName.toLowerCase()), isSelectedSchool);
          });
          enableSelector(item);
        } else {
          item.value = '';
        }
      });
      removeClass(LOADING_CLASS, el);
      removeClass(INVALID_ZIPCODE_CLASS, el);
    };
    const updateState = (data) => {
      stateEl.map(item => {
        if (data && data['features'] && data['features'].length) {
          const schools = data['features'].sort((a, b) => sortByName(a, b));
          // auto-fill state
          const state = schools[0]['attributes']['LSTATE'];
          if (state) {
            item.value = state;
          }
        } else {
          item.value = '';
        }
      });
    };
    const handleZipCodeError = () => {
      if (zipCodeEl.value) {
        const shouldFillBlankStateAndSchool = confirm(zipcodeErrorMessage);
        if (shouldFillBlankStateAndSchool) {
          addClass(INVALID_ZIPCODE_CLASS, el);
          schoolEl.map(item => {
            appendOption(item, '-', true, '-');
          });
          stateEl.map(item => {
            appendOption(item, '-', true, '-');
          });
        }
      }
      removeClass(LOADING_CLASS, el);
    };
    const generateFormData = () => {
      const results = {};
      const formObject = jQuery(form).serializeArray();
      if (formObject) {
        const filteredFormData = formObject.filter(field => field.value && field.name.indexOf('input_') > -1);
        filteredFormData.map(field => {
          const fieldEl = select(`[name="${field.name}"]`, form);
          const fieldLabel = fieldEl.getAttribute('placeholder');
          if (fieldLabel && fieldLabel.indexOf('Password') === -1) {
            results[fieldLabel] = field.value;
          }
        });
      }
      return results;
    };
    const handleZipCodeChange = () => {
      // zipcode must have 5 digits
      if (zipCodeEl.value.replace('_', '').length !== 5) {
        return;
      }
      addClass(LOADING_CLASS, el);
      schoolEl.map(item => {
        if (MBSchool) return;
        appendOption(item, '', true, 'Loading school...');
      });
      stateEl.map(item => {
        item.value = '';
      });
      jQuery.ajax({
        url : wpVars['ajaxUrl'],
        data : {
          action : 'nces_find_by_zipcode',
          zip: zipCodeEl.value,
          form_data: JSON.stringify(generateFormData())
        },
        method : 'GET',
        success: function (res) {
          if (
            res.success &&
            res.data &&
            res.data.hasOwnProperty('features') &&
            res.data['features'].length
          ) {
            if (!MBSchool) {
              updateSchool(res.data);
            } else {
              removeClass(LOADING_CLASS, el);
              removeClass(INVALID_ZIPCODE_CLASS, el);
            }
            updateState(res.data);
          } else {
            handleZipCodeError();
          }
        },
        error: function (error) {
          handleZipCodeError();
          console.error(error);
        }
      });
    };

    const handleEmailChange = () => {
      if (emailEl && !emailEl.value) return;
      addClass(LOADING_CLASS, el);
      jQuery.ajax({
        url : wpVars['ajaxUrl'],
        data : {
          action : 'oac_get_school_domain',
          email: emailEl.value
        },
        method : 'GET',
        success: function (res) {
          if (
            res.success &&
            res.data
          ) {
            const { schoolName } = res.data
            jQuery(SCHOOL_GROUP_CLASS).addClass('gfield-state')
            schoolName && schoolEl.map(item => {
              item.innerHTML = ''
              appendOption(item, schoolName, true, schoolName)
            })
            // console.log(schoolName)
            MBSchool = schoolName
          } else {
            jQuery(SCHOOL_GROUP_CLASS).removeClass('gfield-state')
            MBSchool = null
            handleZipCodeChange()
          }
          removeClass(LOADING_CLASS, el)
        },
        error: function (error) {
          console.error(error);
          MBSchool = null
          handleZipCodeChange()
          removeClass(LOADING_CLASS, el)
        }
      });
    }
    // Check School by Email
    handleEmailChange()
    on('keyup', debounce(handleEmailChange, 500), emailEl)

    // running this code on Update account page
    handleZipCodeChange()
    on('keypress', debounce(handleZipCodeChange, 400), zipCodeEl)
  }

  if(jobProfessor && gradeCollege) {
    jobProfessor.addEventListener('change', () => {
        gradeCollege.checked = true
    })
  }

  if (form) {
    const formID = '#' + getAttribute('id', form);
    delegate('change', () => {
      const schoolEl = select(schoolElClass);
    }, formID, document);
  }

  jQuery(document).on('gform_post_render', function(event, form_id, current_page) {
    if (parseInt(options.formId) === parseInt(form_id)) {
      // If there are validation errors, reinitialize the module
      if (jQuery('.gform_validation_error').length > 0) {
        initializeModuleForEl(el);
      }
    }
  });

  function autocomplete(inp, arr) {
    /*the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    let currentFocus;
    let lastSearchTerm = '';
    let lastResults = [];

    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (let i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }

    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) {
        return false;
      }
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus >= x.length) {
        currentFocus = 0;
      }
      if (currentFocus < 0) {
        currentFocus = (x.length - 1);
      }
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    }

    function closeAllLists(elmnt) {
      /*close all autocomplete lists in the document,
      except the one passed as an argument:*/
      const x = document.getElementsByClassName("autocomplete-items");
      for (let i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }

    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function(e) {
      var a, b, i, val = this.value;
      // console.log('Searching for:', val);
      /*close any already open lists of autocompleted values*/
      closeAllLists();
      if (!val) { return false;}
      currentFocus = -1;

      // Check if we can reuse previous results
      if (val.startsWith(lastSearchTerm) && lastResults.length > 0) {
        // console.log('Reusing previous results for:', val);
        const filteredResults = lastResults.filter(item =>
          item.toUpperCase().startsWith(val.toUpperCase())
        );
        // console.log('Filtered results:', filteredResults.length);
        if (filteredResults.length > 0) {
          createAutocompleteList(filteredResults);
          return;
        }
      }

      const startTime = performance.now();
      const searchTerm = val.toUpperCase();
      const matches = [];

      // Log the search term and array length for debugging
      // console.log('Search term:', searchTerm);
      // console.log('Array length:', arr.length);

      for (i = 0; i < arr.length; i++) {
        const item = arr[i];
        if (item && typeof item === 'string' && item.toUpperCase().startsWith(searchTerm)) {
          matches.push(item);
        }
      }

      const endTime = performance.now();
      // console.log(`Search took ${endTime - startTime}ms for "${val}", found ${matches.length} matches`);
      // console.log('First 5 matches:', matches.slice(0, 5));

      if (matches.length > 0) {
        lastSearchTerm = val;
        lastResults = matches;
        createAutocompleteList(matches);
      } else {
        // console.log('No matches found for:', val);
      }
    });

    function createAutocompleteList(matches) {
      // console.log('Creating autocomplete list with', matches.length, 'items');
      const a = document.createElement("ul");
      a.setAttribute("id", inp.id + "autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      inp.parentNode.appendChild(a);

      matches.forEach(match => {
        const b = document.createElement("li");
        b.innerHTML = "<strong>" + match.substr(0, inp.value.length) + "</strong>";
        b.innerHTML += match.substr(inp.value.length);
        b.innerHTML += "<input type='hidden' value='" + match + "'>";
        b.addEventListener("click", function(e) {
          inp.value = this.getElementsByTagName("input")[0].value;
          closeAllLists();
        });
        a.appendChild(b);
      });
      // console.log('Autocomplete list created with', matches.length, 'items');
    }

    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function (e) {
      let x = document.getElementById(this.id + "autocomplete-list");
      if (x) {
        x = x.getElementsByTagName('li');
      }
      if (e.keyCode === 40) {
        /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
        currentFocus++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode === 38) { //up
        /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
        currentFocus--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode === 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (x) {
            x[currentFocus].click();
          }
        }
      }
    });

    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
      closeAllLists(e.target);
    });
  }

  const generateAfiliationOptions = (res) => {
    if (res) {
      // console.log('Total affiliation items:', res.length);
      // Log the first and last few items to verify data integrity
      // console.log('First 5 items:', res.slice(0, 5));
      // console.log('Last 5 items:', res.slice(-5));

      /*initiate the autocomplete function on the "myInput" element, and pass along the affilications array as possible autocomplete values:*/
      const listIptAutocomplete = document.querySelectorAll(".ginput_container_text > .js-affiliation")
      // console.log('Found input elements:', listIptAutocomplete.length);
      if (listIptAutocomplete) {
        listIptAutocomplete.forEach(ipt => {
          autocomplete(ipt, res);
        })
      }
    }
  };

  const apiPath = `${window.location.origin}/wp-json/ecl/v1/afiliation`;
  fetchData(apiPath).then(generateAfiliationOptions);

  const generateSchoolNameOptions = (res) => {
    // remove null/undefined value from res and check only if res is not empty
    res = res.filter(val => val);
    if (res && res.length > 0) {
      const listIptSchoolAutocomplete = document.querySelectorAll(".ginput_container_text > .js-school-name")
      if (listIptSchoolAutocomplete) {
        listIptSchoolAutocomplete.forEach(ipt => {
          autocomplete(ipt, res);
        })
      }
    }
  };

  const apiPathSchoolName = `${window.location.origin}/wp-json/ecl/v1/list-school-name`;
  fetchData(apiPathSchoolName).then(generateSchoolNameOptions);
}
